import { render } from "./Design_SMS_Template.vue?vue&type=template&id=388712e0&scoped=true"
import script from "./Design_SMS_Template.vue?vue&type=script&lang=js"
export * from "./Design_SMS_Template.vue?vue&type=script&lang=js"

import "./Design_SMS_Template.vue?vue&type=style&index=0&id=388712e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388712e0"]])

export default __exports__